import { useEffect, useState } from 'react';
import ImageContent from '@apps/components/ImageContent';
import { SectionTitle } from '@apps/components/SectionTitle';
import getNewsListing from '@apps/config/API/listing.config';
import { getDateSlug } from '@apps/utils/get-date-slug';
import { localeConversions } from '@apps/utils/locale-conversion';
import EastIcon from '@mui/icons-material/East';
import { Divider, Stack, Typography } from '@mui/material';
import placeholderImage from '@stack/assets/images/empty_placeholder.jpg';
import createBasePath from '@stack/helpers/lib/createBasePath';
import { toLower } from 'lodash';
import Error from 'next/error';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';

import { ContentWrapper } from './styles';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const CarLaunchNews = (props: any) => {
  const { webView } = props;

  const router = useRouter();
  const [newsData, setNewsData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  const { lang } = useTranslation('common');
  const newLang = localeConversions(lang);

  const { basePath } = createBasePath({
    webView,
    type: 'news',
  });

  const getPostHref = (post: any) => {
    if (!post?.post_title) return;
    const dateSlug = getDateSlug(post.post_created);
    return webView
      ? `/webview/${dateSlug}/${toLower(post?.post_slug)}`
      : `/${dateSlug}/${toLower(post?.post_slug)}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const category = 'new-car';
        setLoading(true);

        const res = await getNewsListing({
          pageSize: 8,
          page: 1,
          locale: newLang,
          postCategory: category as string,
        });
        if (res.data.length < 1) {
          return <Error statusCode={404} />;
        }

        setNewsData(res.data);
        setLoading(false);
      } catch (err) {
        console.log('error', err);
      }
    };
    fetchData();
  }, [router.locale, newLang]);

  return (
    <ContentWrapper>
      <SectionTitle title="News" containerProps={{ marginTop: 20 }} />
      <Stack divider={<Divider orientation="horizontal" flexItem />}>
        <Stack gap={5} style={{ marginBottom: 10 }}>
          {newsData &&
            newsData.map((news: any, index: any) => {
              return (
                <ImageContent
                  key={index}
                  title={news.post_title}
                  titleSlug={news?.post_slug}
                  description={news.post_short_description}
                  badgeLabel={news?.category_name}
                  footerText={news?.post_created}
                  imageProps={{
                    src: news?.post_thumbnail_id || placeholderImage.src,
                    width: 600,
                    height: 315,
                    alt: news?.post_title,
                  }}
                  imagePosition="top"
                  tabletImagePosition="top"
                  mobileImagePostion="top"
                  maxImageWidth={'100%'}
                  author={news?.post_author}
                  authorAvatar={news?.post_author_profile_image}
                  authorEmail={news?.post_author_username}
                  titleClass="custom-text-xl"
                  descriptionLine={3}
                  href={getPostHref(news)}
                  loading={loading}
                  webView={webView}
                  hideDescription={true}
                  isList
                />
              );
            })}
        </Stack>

        {!webView && (
          <Link
            href={`${basePath}/new-car`}
            onClick={() => {
              router.push(`${basePath}/new-car`);
            }}
          >
            <Stack
              spacing={1.5}
              direction="row"
              sx={{
                p: 2.5,
                alignItems: 'center',
                justifyContent: 'center',
                ':hover': {
                  backgroundColor: '#F7F7F7 !important',
                },
              }}
            >
              <Typography fontSize={16} fontWeight={700} textAlign={'center'}>
                Show More
              </Typography>
              <EastIcon sx={{ width: 20, height: 20, color: '#1E242F' }} />
            </Stack>
          </Link>
        )}
      </Stack>
    </ContentWrapper>
  );
};
